type END_POINTS_TYPES = {
    rankingApi: string
    seasonAPI: string
    nftDetailApi: string
    productsAPI: string
    userAPIS: string
    reporting: string
    searchApi: string
    registrationsApi: string
    configApi: string
    checkUserLink: string
    seasonStatusApi: string
}

const host = window.location.hostname
const isThHost = host.includes('.co.th')

export const END_POINTS: END_POINTS_TYPES = {
    rankingApi: 'ranks/',
    registrationsApi: 'fundmanagement/v1/registrations',
    seasonAPI: 'fundmanagement/v1/seasons/',
    nftDetailApi: 'fundmanagement/v1/nft/',
    productsAPI: isThHost
        ? 'https://apexapi.bitazza.co.th:8443/AP/GetProducts?OMSId=1'
        : 'https://apexapi.bitazza.com:8443/AP/GetProducts?OMSId=1',
    userAPIS: 'users/',
    reporting: '/reporting/accounts/',
    searchApi: 'users/rank/MOCK',
    configApi: '/mock-trading/configs',
    checkUserLink: '/user/link/check/',
    seasonStatusApi: 'fundmanagement/registrations',
}
